module.exports = __webpack_public_path__ + "img/links.26bb1914.svg";